import { gql } from "@apollo/client"
import { TeamPostInfoFragment } from "@pallet/features/PostType/TeamPostInfo/fragment"

export const PostSectionFragment = gql`
    fragment MiniTeamProfilePostSectionFragment on PostTypeConnection {
        totalCount
        edges {
            node {
                id
                ...TeamPostInfo_post
            }
        }
    }
    ${TeamPostInfoFragment}
`
